import { Card, Tabs } from 'components/core-v2'
import { NoteDetailsTable } from 'components/core-v2/organisms/tables/note-details'
import { useParams } from 'react-router-dom'

export const DetailsNoteTab = () => {
  const { source, tradeId } = useParams()

  return (
    <Tabs.Panel value="note">
      <Card.Wrapper>
        <NoteDetailsTable accountId={tradeId} accountSource={source} />
      </Card.Wrapper>
    </Tabs.Panel>
  )
}
